module.exports = __webpack_public_path__ + "img/bg-img1.4c06b17a.png";